import React, { useEffect, useState } from "react";
import { GetServerSidePropsContext } from "next";
import Head from "next/head";
import { useTranslations } from "next-intl";
import { useRouter } from "next/router";
import { useAppDispatch, useAppSelector } from "custom-hooks/redux.hooks";
import { CPagesPath } from "shared/models/const/pages-path";
import UserSettingsLayout from "shared/layouts/user-settings";
import styled from "@emotion/styled";
import { ModalMessage } from "@components/message-modal";
import ChangePasswordForm from "@components/forms/change-passowrd-form";
import { en,es} from "@lang"

export async function getServerSideProps({
  locale,
}: GetServerSidePropsContext) {
  return {
    props: {
      messages: locale === "es" ? es : en,
    },
  };
}

function CambiarClavePage(props: any) {
  const titleT = useTranslations("title-pages");
  const t = useTranslations("ProfileChangePassword");
  const router = useRouter();
  const user = useAppSelector((state) => state.Auth.user);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);

  useEffect(() => {
    if (!user) router.push(CPagesPath.es.signin);
  });

  if (!user) return null;

  const onSubmitSuccess = () => setShowSuccessAlert(true);

  return (
    <>
      <Head>
        <title>{titleT("profile-update-password")}</title>
      </Head>
      <Container>
        <PageTitle>{t("title")}</PageTitle>
        <ChangePasswordForm onSubmitSuccess={onSubmitSuccess} />
        <SuccessModal open={showSuccessAlert} />
      </Container>
    </>
  );
}

interface ISuccessModal {
  open: boolean;
}

function SuccessModal({ open }: ISuccessModal) {
  const t = useTranslations("ProfileChangePassword.success");
  const router = useRouter();

  return (
    <ModalMessage
      open={open}
      title={t("title")}
      body={t("message")}
      handleClose={() => router.push(CPagesPath.es.profile)}
      buttonText={t("link")}
    />
  );
}

CambiarClavePage.Layout = UserSettingsLayout;
export default CambiarClavePage;

const PageTitle = styled.h1`
  color: var(--color-brand-blue-main);
  font-weight: 500;
  margin-bottom: 30px;
`;

const Container = styled.section`
  max-width: 820px;
  margin: auto;
  padding: 30px 20px;
`;
